import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';

function useCashGiftRecommended() {
    const { data } = useQuery(queries.recommendedItems.gift('CASH'));
    return data;
}

export default useCashGiftRecommended;
